import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { 
  FaShieldAlt, 
  FaShippingFast, 
  FaClock, 
  FaCreditCard, 
  FaCheckCircle, 
  FaHeadset, 
  FaAward, 
  FaStar, 
  FaQuoteLeft, 
  FaArrowRight,
  FaUserTie
} from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";
import api from "../axios/api";

const AboutUs = () => {
  const [equipa, setEquipa] = useState([]);

  useEffect(() => {
    let isMounted = true;

    const fetchEquipa = async () => {
      try {
        const res = await api.get("/equipes");
        const dadosEquipa = Array.isArray(res.data) ? res.data : (res.data.data || []);
        if (isMounted) {
          setEquipa(dadosEquipa);
        }
      } catch (error) {
        console.error("Erro ao buscar equipa:", error);
      }
    };

    fetchEquipa();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <main className="bg-white text-dark">
      <Header />

      {/* Hero Section */}
      <section className="bg-black text-white py-5 position-relative overflow-hidden">
        <div className="container py-5 text-center position-relative z-2">
          <span className="text-warning fw-bold text-uppercase tracking-wider small mb-3 d-block">
            Sobre Nós
          </span>
          <h1 className="display-4 fw-bold mb-4">
            Tecnologia & Formação <span className="text-warning">—</span> Soluções e Capacitação
          </h1>
          <p className="lead text-light opacity-75 mx-auto mb-4" style={{ maxWidth: '700px' }}>
            Anos de experiência em inovação tecnológica, capacitação profissional e suporte de excelência em Angola.
          </p>
          <div className="d-inline-block border border-secondary rounded-3 px-4 py-3 bg-dark mt-2 shadow-sm">
            <span className="text-warning fw-semibold small d-block">CENFOTEP — Centro de Formação & Tecnologias</span>
            <span className="text-muted small">Excelência, Prática e Inovação para o Mercado</span>
          </div>
        </div>
      </section>

      {/* Value Proposition Cards */}
      <section className="py-5 bg-white">
        <div className="container py-4">
          <div className="row g-4">
            {[
              {
                icon: <FaShieldAlt size={32} className="text-warning" />,
                title: "Qualidade Garantida",
                desc: "Se não ficar satisfeito, refazemos o trabalho sem custos adicionais.",
                tag: "100% GARANTIA"
              },
              {
                icon: <FaShippingFast size={32} className="text-warning" />,
                title: "Entrega em Todo País",
                desc: "Entregamos em Angola inteira com rastreamento em tempo real.",
                tag: "ENTREGA NACIONAL"
              },
              {
                icon: <FaClock size={32} className="text-warning" />,
                title: "Produção Express",
                desc: "Pedidos urgentes produzidos e entregues em 24 a 48 horas.",
                tag: "24-48H EXPRESS"
              },
              {
                icon: <FaCreditCard size={32} className="text-warning" />,
                title: "Pagamento Seguro",
                desc: "Múltiplas formas de pagamento com total segurança e transparência.",
                tag: "PAGAMENTO FLEXÍVEL"
              }
            ].map((item, idx) => (
              <div key={idx} className="col-md-6 col-lg-3">
                <div className="card h-100 border border-light shadow-sm p-4 text-center rounded-4 bg-light hover-shadow transition">
                  <span className="badge bg-warning text-dark align-self-center mb-3 px-3 py-1 fw-bold" style={{ fontSize: '0.65rem' }}>{item.tag}</span>
                  <div className="mb-3 d-flex justify-content-center">{item.icon}</div>
                  <h4 className="h5 fw-bold mb-2">{item.title}</h4>
                  <p className="text-muted small mb-0">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Statistics Banner */}
      <section className="bg-black text-white py-5">
        <div className="container">
          <div className="row text-center g-4">
            <div className="col-6 col-md-3">
              <span className="display-4 fw-bold text-warning d-block mb-1">8+</span>
              <span className="text-light opacity-75 small">Anos no Mercado</span>
            </div>
            <div className="col-6 col-md-3">
              <span className="display-4 fw-bold text-warning d-block mb-1">500+</span>
              <span className="text-light opacity-75 small">Empresas Confiam em Nós</span>
            </div>
            <div className="col-6 col-md-3">
              <span className="display-4 fw-bold text-warning d-block mb-1">10.000+</span>
              <span className="text-light opacity-75 small">Produtos Entregues</span>
            </div>
            <div className="col-6 col-md-3">
              <span className="display-4 fw-bold text-warning d-block mb-1">98%</span>
              <span className="text-light opacity-75 small">Taxa de Satisfação</span>
            </div>
          </div>
        </div>
      </section>

      {/* Equipa Section */}
      <section className="py-5 bg-light">
        <div className="container py-4">
          <div className="text-center mb-5">
            <span className="text-warning fw-bold text-uppercase tracking-wider small mb-2 d-block">Profissionais Qualificados</span>
            <h2 className="fw-bold display-5">Nossa Equipa</h2>
          </div>
          <div className="row g-4 justify-content-center">
            {equipa.length > 0 ? (
              equipa.map((membro, index) => (
                <div key={membro.id || index} className="col-md-6 col-lg-3">
                  <div className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden bg-white text-center">
                    <div className="position-relative" style={{ height: '220px', backgroundColor: '#111' }}>
                      {membro.foto || membro.imagem ? (
                        <img 
                          src={membro.foto || membro.imagem} 
                          alt={membro.nome} 
                          className="w-100 h-100 object-fit-cover"
                        />
                      ) : (
                        <div className="w-100 h-100 d-flex align-items-center justify-content-center bg-dark text-warning">
                          <FaUserTie size={64} />
                        </div>
                      )}
                    </div>
                    <div className="card-body p-4 d-flex flex-column">
                      <h5 className="fw-bold mb-1">{membro.nome}</h5>
                      <span className="text-warning small fw-semibold mb-2">{membro.cargo || membro.funcao || "Especialista"}</span>
                      {membro.descricao && (
                        <p className="text-muted small mb-0 mt-2">{membro.descricao}</p>
                      )}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12 text-center py-4">
                <p className="text-muted">Nenhum membro da equipa registado de momento.</p>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Trust Badges Bar */}
      <section className="py-4 bg-white border-bottom">
        <div className="container">
          <div className="row text-center justify-content-center g-3 text-secondary small fw-semibold">
            <div className="col-auto d-flex align-items-center gap-2"><FaCheckCircle className="text-warning" /> Dados Protegidos</div>
            <div className="col-auto d-flex align-items-center gap-2"><FaAward className="text-warning" /> Certificação de Qualidade</div>
            <div className="col-auto d-flex align-items-center gap-2"><FaHeadset className="text-warning" /> Suporte Dedicado</div>
            <div className="col-auto d-flex align-items-center gap-2"><FaCheckCircle className="text-warning" /> Garantia de Satisfação</div>
            <div className="col-auto d-flex align-items-center gap-2"><FaAward className="text-warning" /> Empresa Verificada</div>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
};

export default AboutUs;